import { render, staticRenderFns } from "./MobileSubscriptionWizard.vue?vue&type=template&id=10885e20&scoped=true"
import script from "./MobileSubscriptionWizard.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./MobileSubscriptionWizard.vue?vue&type=script&charset=utf-8&lang=js"
import style0 from "./MobileSubscriptionWizard.vue?vue&type=style&index=0&id=10885e20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10885e20",
  null
  
)

export default component.exports